import React, { useEffect, useState } from "react";
import { Spinner } from "reactstrap";
import './file-icons.scss';
import Axios from 'axios';
import ProgressBar from "../../../newComponents/progressBar/ProgressBar";
const fileFormatIcons = [
"7Z",
"AAC",
"AEP",
"AI",
"AVI",
"AZW",
"BAT",
"BIN",
"BMP",
"CDR",
"CSS-01",
"CSS-02",
"CSV",
"DAT",
"DJVU",
"DLL",
"DMG",
"DOC",
"DOCX",
"EML",
"EPS",
"EPUB",
"EXE",
"FLA",
"FLAC",
"GIF",
"HTML",
"ICO",
"INDD",
"INI",
"ISO",
"JAR",
"JPEG",
"JPG",
"JS",
"KEY",
"MIDI",
"MKV",
"MOBI",
"MOV",
"MP3",
"MP4",
"NFO",
"NUMBERS",
"OGG",
"OTF",
"PAGES",
"PDF",
"PHP",
"PNG",
"PPT",
"PPTX",
"PSD",
"RAR",
"RAW",
"RTF",
"SQL",
"SUB",
"SVG",
"SWF",
"SYS",
"TTF",
"TXT",
"URL",
"WAV",
"WMV",
"XLS",
"XLSX",
"XML",
"ZIP"
]

// const Blob = ({url}) => {
//   console.log(url)
//   let pdfRendering = <div>Rendering</div>
//   let bloo = null
//   const getBlob = async () => {
//     return await Axios.get(url, {
//       responseType: 'blob',
//       })
//       .then( (res) => {
//         console.log(res)
//         bloo = res.data
//         // pdfRendering = "rendered"
//         // pdfRendering = <iframe scr={URL.createObjectURL(res.data)}></iframe>
//       })
//   }
//   if(bloo){
//     console.log(getBlob())
//     pdfRendering = <div>Rendered</div>
//   }
  

//   return pdfRendering
  
// }

const FileIcon  = ({ file, metadata, scope, imageType }) => {

    const [ preview, setPreview] = useState({
      loading: false,
      blob: null,
      progress: 0,
    })
    useEffect(() => {

      async function fetchData() {
        setPreview( prevState => {
          return {
            ...prevState,
            loading: true
          }
        })
        await Axios.get(file.url, {
          responseType: 'blob',
          onDownloadProgress: (progressEvent) => {
            const progress = (progressEvent.loaded / progressEvent.total) * 100;
            setPreview((prevState) => ({
              ...prevState,
              progress,
            }));
          }  
          })
          .then( (res) => {
            console.log(res.data)
            setPreview( prevState => {
              return {
                ...prevState,
                loading: false,
                blob: URL.createObjectURL(res.data)
              }
            })
          })
  
      }

      if(file && file.fileName.split('.').pop().toLowerCase() === 'pdf' || 
        file && file.contentType.split('/')[0].toLowerCase() === 'video'
      ){
        fetchData();
      } else {
        setPreview( prevState => {
          return {
            ...prevState,
            loading: false
          }
        })
      }
      return () => {

      }
    }, [file])

    const fileExtension = file.fileName.split('.').pop()
    const fileType = file.contentType.split('/')[0]
    const specificIcon = fileFormatIcons.find( f => f.toLowerCase() === fileExtension.toLowerCase() )

    return fileType === 'video' ?
              <div className={`${scope !== 'iconOnly' ? 'video': 'video-icon'}`} key={file.url}>
                {preview?.loading ? 
                <div>
                  <ProgressBar progress={preview?.progress} />
                </div>
              :
              <video controls={scope !== 'iconOnly' ? true : false}>
                <source src={preview.blob} type="video/mp4"/>
                Your browser does not support the video tag.
              </video>
              }
              </div>
              :
            fileType === 'image' ?
            <>
            {imageType === "background" ? 
              <div className="image-file-background" style={{ backgroundImage: `url(${file.url})` }}></div> : 
              <img className={file.contentType === "image/webp" ? "sticker" : "thumbnail"} src={file.url} />
            }
            </> : 
            fileType === 'audio' && scope !== 'iconOnly' ?
              <audio controls controlsList="nodownload" type='audio/mpeg'>
                <source 
                  key={file.url}
                  src={file.url} 
                  type={file.contentType}
                />
              </audio>
            : file.contentType.toLowerCase() === 'application/pdf' && scope !== 'iconOnly' ?
              <div className="pdf-file">
                {preview && preview.loading ? 
                  <div className="pdf-loading">
                    <img className="icon" src={require('../../../assets/img/svg/mimetype/'+specificIcon+'.svg')} />
                    {metadata && <div className="metadata">{file.fileName}</div>}
                    <Spinner color="primary" />
                  </div> :
                  <iframe src={preview.blob} frameBorder='0' className='media-view-pdf' style={{backgroundColor: '#FFFFFF'}} />
                }
              </div>
            :
            typeof specificIcon !== 'undefined' ? 
            <div>
              <img className="icon" src={require('../../../assets/img/svg/mimetype/'+specificIcon+'.svg')} />
              {metadata && <div className="metadata">{file.fileName}</div>}
            </div> :
            <div><img className="icon" src={require('../../../assets/img/svg/mimetype/Default.svg')} /></div>
  }

export default (FileIcon)